// What is happening to the site's files right now: uploads and conversions
// on the media server, relayed through the core backend. The backend is the
// only one that knows the whole picture (uploads from any session, conversion
// progress that happens after the upload dialog closed), so this module only
// polls one endpoint and hands the list to whoever renders it.
//
// Polling pace follows the work: fast while something is running, slow when
// the list is quiet. A failed poll never throws anywhere — the list just
// stays as it was and the next tick tries again.

import http from "./http";

const state = {
  entries: [],
  listeners: new Set(),
  timer: null,
  failures: 0,
};

const ACTIVE = ["uploading", "processing", "converting"];

function notify() {
  for (const listener of state.listeners) {
    try {
      listener(state.entries);
    } catch (e) {
      // A broken listener must not stop the others.
    }
  }
}

export function getProcesses() {
  return state.entries;
}

export function onProcesses(listener) {
  state.listeners.add(listener);
  return () => state.listeners.delete(listener);
}

export function activeCount() {
  return state.entries.filter((entry) => ACTIVE.includes(entry.status)).length;
}

function schedule() {
  clearTimeout(state.timer);
  const base = activeCount() > 0 ? 5000 : 30000;
  const delay = base * (1 + state.failures);
  state.timer = setTimeout(refresh, delay);
}

async function refresh() {
  try {
    const data = await http.fetch("/files/processes");
    const list = Array.isArray(data?.processes) ? data.processes : [];
    state.entries = list;
    state.failures = 0;
    notify();
  } catch (e) {
    state.failures = Math.min(state.failures + 1, 6);
  } finally {
    if (state.timer !== null) {
      schedule();
    }
  }
}

export function startProcessLog() {
  if (state.timer === null) {
    state.timer = setTimeout(refresh, 0);
  }
}

export function stopProcessLog() {
  clearTimeout(state.timer);
  state.timer = null;
}
